// extracted by mini-css-extract-plugin
export default {"menuBlock":"eF-z","title":"fF-z","nav":"gF-z","flexCell":"hF-z","facetLink":"iF-z"};